import styled from 'styled-components';

import ContentHeaderStyled from '../../../components/ContentHeader';
import HoverableCard from '../../../components/HoverableCard';
import PaginationStyled from '../../../components/Pagination';
import { CHART_DESCRIPTIONS } from '../chartDescriptions';

interface Props {
  className?: string;
}

const DiagramsPage = ({ className = '' }: Props) => (
  <div className={className}>
    <div className="content">
      <ContentHeaderStyled
        className="breadcrumbs"
        title="Diagrams"
        breadcrumbs={[
          { label: 'Data Visualization', url: '/data-visualization' },
          { label: 'Diagrams Chart' },
        ]}
      />

      <div className="cards">
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/diagrams/sankey']}
          title="Sankey Diagram"
          url="sankey"
          image="/images/data-viz-diagrams/sankey.png"
          tags={['correlation', 'proportion']}
        />
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/diagrams/treemap']}
          title="Treemap"
          url="treemap"
          image="/images/data-viz-diagrams/treemap.png"
          tags={['proportion']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/diagrams/circle']}
          title="Circle Packing"
          url="circle"
          image="/images/data-viz-diagrams/circle-packing.png"
          tags={['comparison']}
        />
      </div>

      <PaginationStyled
        previousLink="/data-visualization/circulars"
        previous="Circulars"
        nextLink="/data-visualization/others"
        next="Others"
        className="footer-pagination"
      />
    </div>
  </div>
);

const StyledDiagramsPage = styled(DiagramsPage)`
  > .sidebar {
    overflow-x: hidden;
    height: calc(100vh - 4rem);
  }

  > .content {
    overflow-x: hidden;
    margin: 0 auto;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;

    > .breadcrumbs {
      margin-bottom: 24px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-bottom: 40px;
      }
    }

    > .cards {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 80px;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    > .footer-pagination {
      display: none;
      margin-top: auto;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: block;
      }
    }
  }
`;

export default StyledDiagramsPage;
